import {Trans, useTranslation} from '@/translations/i18n.tsx'
import {Spinner} from '@components/ui/spinner'
import {useNavigate, useSearchParams} from 'react-router-dom'
import {useEffect} from 'react'
import {routes} from '@utilities/constants/routes'
import {usePhotographersSsoLogin} from '@features/user/queries/usePhotographersSsoLogin'
import {errorHandler} from '@utilities/helpers'
import {toast} from '@utilities/toast'
import {AlertCircleIcon} from '@components/ui/icon'
import {AxiosError} from 'axios'
import {useLogout} from '@features/user/queries/useLogout'
import RHT from 'react-hot-toast'

const toastId = 'connected_to_another_account_toast'

export const SsoRedirect = () => {
    const navigate = useNavigate()
    const {t} = useTranslation()
    const [searchParams] = useSearchParams()

    const SSOCode = searchParams.get('code')
    const redirectUrl = localStorage.getItem('navigate-login-redirect-url')
    const logoutMutation = useLogout()

    const photographersSsoLogin = usePhotographersSsoLogin({
        onError: error => {
            if (
                error instanceof AxiosError &&
                error.response?.data?.message == 'photographer_already_exists' &&
                error.response?.status == 409
            ) {
                navigate(routes.LINK_AIRBNB_ACCOUNT.handle.fullPath, {replace: true})
                toast.info(
                    <div className="flex flex-col gap-1">
                        <h3 className="text-sm font-medium">
                            {t('link_airbnb_account:connected_to_another_account_title')}
                        </h3>
                        <p className="text-sm">
                            <Trans
                                i18nKey="link_airbnb_account:connected_to_another_account_description"
                                components={[
                                    <button
                                        className="text-sm underline cursor-pointer bg-none border-none p-0 m-0"
                                        onClick={() => {
                                            logoutMutation.mutate()
                                            RHT.dismiss(toastId)
                                        }}
                                    />,
                                    <a
                                        href="mailto:photography@airbnb.com"
                                        target="_blank"
                                        className="text-sm underline cursor-pointer"
                                    />
                                ]}
                            />
                        </p>
                    </div>,

                    {
                        position: 'bottom-center',
                        icon: <AlertCircleIcon className="text-danger-600 size-5" />,
                        style: {
                            maxWidth: '480px',
                            border: '1px solid var(--color-neutral-300)',
                            borderRadius: '12px'
                        },
                        duration: 5000,
                        id: toastId
                    }
                )
            } else {
                navigate(routes.HOME.handle.fullPath, {replace: true})
                errorHandler(error)
            }
        },
        onSuccess: () => {
            navigate(redirectUrl ?? routes.HOME.handle.fullPath, {replace: true})
            localStorage.removeItem('navigate-login-redirect-url')
        }
    })
    useEffect(() => {
        if (SSOCode) photographersSsoLogin.mutate(SSOCode)
    }, [])

    return (
        <div className="flex justify-center items-center h-full">
            <div className="flex flex-col items-stretch text-center w-90">
                <div className="flex justify-center w-full">
                    <Spinner size={48} className="text-neutral-500" />
                </div>
                <h3 className="text-display-sm font-semibold text-neutral-900 mt-6">{t('redirect:title')}</h3>
                <p className="text-md mt-2 mb-14">{t('redirect:subtitle')}</p>
            </div>
        </div>
    )
}

SsoRedirect.displayName = 'SsoRedirect'
